export const FILTER_DOCUMENT_PARAMS = ['name']

export const DOCUMENT_LOCALIZATION = ['RU', 'EN', 'HY']
